"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalStyles_1 = require("./GlobalStyles");
exports.default = GlobalStyles_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/GlobalStyles/index.js
// module id = 1146
// module chunks = 8